(function () {
  var cfgEl = document.getElementById("PaintroadFlashConfig");
  if (!cfgEl) return;

  var cfg = {};
  try {
    cfg = JSON.parse(cfgEl.textContent || "{}");
  } catch (e) {
    return;
  }

  var code = String(cfg.code || "")
    .trim()
    .toUpperCase();
  if (!code || code.indexOf("TIME") !== 0) return;

  var percent = Number(cfg.percent) || 10;
  var minutes = Number(cfg.minutes) || 30;
  var toastSeconds = Number(cfg.toastSeconds) || 5;
  var popupSeconds = Number(cfg.popupSeconds) || 8;
  var cookieDays = Number(cfg.cookieDays) || 3;
  var pageType = String(cfg.pageType || "");
  var moneyFormat = cfg.moneyFormat || "₹ {{amount}}";
  var cartTotal = Number(cfg.cartTotal) || 0;
  var cartCount = Number(cfg.cartCount);
  if (!isFinite(cartCount)) cartCount = cartTotal > 0 ? 1 : 0;
  var giftCardOnly = !!cfg.giftCardOnly;
  var productIsGiftCard = !!cfg.productIsGiftCard;
  var COOKIE = "pr_flash_offer";
  var SESSION = "pr_flash_offer";
  var durationMs = minutes * 60 * 1000;
  var nativeFetch = window.fetch ? window.fetch.bind(window) : null;

  function readCookie(name) {
    var parts = ("; " + document.cookie).split("; " + name + "=");
    if (parts.length < 2) return "";
    return decodeURIComponent(parts.pop().split(";").shift() || "");
  }

  function writeCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie =
      name + "=" + encodeURIComponent(value) + "; expires=" + d.toUTCString() + "; path=/; SameSite=Lax";
  }

  function loadState() {
    var raw = readCookie(COOKIE);
    if (!raw) {
      try {
        raw = sessionStorage.getItem(SESSION) || "";
      } catch (e) {}
    }
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function saveState(state) {
    var raw = JSON.stringify(state);
    try {
      sessionStorage.setItem(SESSION, raw);
    } catch (e) {}
    writeCookie(COOKIE, raw, cookieDays);
  }

  var state = loadState() || { startedAt: 0, toastDismissed: false };

  function hasStarted() {
    return !!(state && state.startedAt && state.startedBy === "add");
  }

  function remainingMs() {
    if (!hasStarted()) return 0;
    return state.startedAt + durationMs - Date.now();
  }

  function isLive() {
    return hasStarted() && remainingMs() > 0;
  }

  function startTimer() {
    if (state && state.ended) return false;
    if (hasStarted()) return false;
    state.startedAt = Date.now();
    state.startedBy = "add";
    state.toastDismissed = false;
    saveState(state);
    return true;
  }

  function pad(n) {
    return n < 10 ? "0" + n : String(n);
  }

  function clockParts(ms) {
    var total = Math.max(0, Math.ceil(ms / 1000));
    return { m: pad(Math.floor(total / 60)), s: pad(total % 60) };
  }

  function formatPaise(cents) {
    cents = Math.max(0, Math.round(Number(cents) || 0));
    var amount = (cents / 100).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return "₹" + amount;
  }

  function formatMoney(cents) {
    cents = Math.max(0, Math.round(Number(cents) || 0));
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(cents, moneyFormat);
    }
    var whole = Math.round(cents / 100).toLocaleString("en-IN");
    var amount = (cents / 100).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return moneyFormat
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, whole)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function savingsCents() {
    var base = cartTotal;
    if (base <= 0 && cfg.productPrice) base = Number(cfg.productPrice) || 0;
    return Math.round((base * percent) / 100);
  }

  function messageText() {
    var save = savingsCents();
    var base = "Checkout now to get extra " + percent + "% OFF";
    if (save > 0) return base + " - " + formatMoney(save);
    return base;
  }

  function isTimeCode(value) {
    return String(value || "")
      .trim()
      .toUpperCase()
      .indexOf("TIME") === 0;
  }

  var pendingUserCode = null;
  var checkoutDiscount = null;
  var syncGen = 0;

  function cartIsGiftCardOnly(cart) {
    var items = (cart && cart.items) || [];
    if (!items.length) return false;
    return items.every(function (item) {
      return !!(item && item.gift_card);
    });
  }

  function addedIsGiftCard(body) {
    if (!body || typeof body !== "object") return false;
    if (body.gift_card) return true;
    var items = body.items;
    return Array.isArray(items) && items.length > 0 && items.every(function (item) {
      return !!(item && item.gift_card);
    });
  }

  function isWalletCode(value) {
    return String(value || "")
      .trim()
      .toUpperCase()
      .indexOf("WALLET") === 0;
  }

  // The cart wallet widget owns WALLET codes; keep whatever it left on the cart.
  function walletCodes(cart) {
    if (cart) return codesOn(cart).filter(isWalletCode);
    var w = window.PaintroadWallet;
    return w && w.applied ? [String(w.applied).toUpperCase()] : [];
  }

  function discountFor(userCode, cart) {
    var parts = [];
    var user = String(userCode || "").trim().toUpperCase();
    if (user && !isTimeCode(user) && !isWalletCode(user)) parts.push(user);
    walletCodes(cart).forEach(function (w) {
      if (parts.indexOf(w) === -1) parts.push(w);
    });
    if (isLive() && !giftCardOnly && parts.indexOf(code) === -1) parts.push(code);
    return parts.join(",");
  }

  window.PaintroadFlash = {
    code: code,
    isLive: isLive,
    isGiftCardOnly: function () {
      return giftCardOnly;
    },
    isTimeCode: isTimeCode,
    remainingMs: remainingMs,
    replaceCoupon: function (userCode) {
      var user = String(userCode || "").trim().toUpperCase();
      syncGen += 1;
      pendingUserCode = user && !isTimeCode(user) ? user : "";
      discountPush = null;
      checkoutDiscount = discountFor(pendingUserCode);
      return checkoutDiscount;
    },
    endTimer: function () {
      state.ended = true;
      state.startedAt = 0;
      state.startedBy = "";
      state.toastDismissed = true;
      saveState(state);
      syncGen += 1;
      discountPush = null;
      var user = pendingUserCode;
      if (user === null && checkoutDiscount) {
        var kept = String(checkoutDiscount)
          .split(",")
          .map(function (part) {
            return part.trim().toUpperCase();
          })
          .filter(function (part) {
            return part && !isTimeCode(part);
          });
        user = kept.length ? kept[kept.length - 1] : "";
        pendingUserCode = user;
      }
      checkoutDiscount = discountFor(user || "");
      syncCheckoutCodes();
      if (popup) popup.classList.remove("is-open");
      paint();
    },
  };

  function renderClock(el, parts) {
    var mm = el.querySelector("[data-mm]");
    var ss = el.querySelector("[data-ss]");
    if (!mm || !ss) {
      el.innerHTML =
        '<span class="pr-flash-clock__seg"><span class="pr-flash-clock__num" data-mm></span><span class="pr-flash-clock__unit">min</span></span>' +
        '<span class="pr-flash-clock__sep" aria-hidden="true">:</span>' +
        '<span class="pr-flash-clock__seg"><span class="pr-flash-clock__num" data-ss></span><span class="pr-flash-clock__unit">sec</span></span>';
      mm = el.querySelector("[data-mm]");
      ss = el.querySelector("[data-ss]");
    }
    mm.textContent = parts.m;
    ss.textContent = parts.s;
    el.setAttribute("aria-label", parts.m + " minutes " + parts.s + " seconds left");
  }

  function isMobile() {
    try {
      return window.matchMedia("(max-width: 989px)").matches;
    } catch (e) {
      return false;
    }
  }

  // Desktop PDP keeps the inline strip for the full window instead of the popup.
  function popupAllowed() {
    if (productIsGiftCard || giftCardOnly) return false;
    if (pageType === "index" || pageType === "collection") return true;
    return pageType === "product" && isMobile();
  }

  var popup = document.querySelector("[data-pr-flash-toast]");
  var popupTimer = null;

  function openPopup(mode) {
    if (!popup || !offerVisible()) return;
    var tag = popup.querySelector("[data-pr-flash-pop-tag]");
    if (tag) tag.textContent = mode === "atc" ? "Deal unlocked" : "Limited-time deal";
    popup.classList.remove("is-open");
    void popup.offsetWidth;
    popup.classList.add("is-open");
    paint();
    window.clearTimeout(popupTimer);
    popupTimer = window.setTimeout(closePopup, (mode === "atc" ? popupSeconds : toastSeconds) * 1000);
  }

  function closePopup() {
    window.clearTimeout(popupTimer);
    if (popup) popup.classList.remove("is-open");
    if (!state.toastDismissed) {
      state.toastDismissed = true;
      saveState(state);
    }
  }

  function paint() {
    var live = isLive();
    var remain = remainingMs();
    var parts = clockParts(remain);
    var save = savingsCents();
    var progress = Math.max(0, Math.min(100, (1 - remain / durationMs) * 100));

    document.querySelectorAll("[data-pr-flash-msg]").forEach(function (el) {
      el.textContent = messageText();
    });
    document.querySelectorAll("[data-pr-flash-timer]").forEach(function (el) {
      el.textContent = parts.m + ":" + parts.s;
    });
    document.querySelectorAll("[data-pr-flash-clock]").forEach(function (el) {
      renderClock(el, parts);
    });
    document.querySelectorAll("[data-pr-flash-save]").forEach(function (el) {
      el.textContent = live ? "-" + formatMoney(save) : "";
    });
    document.querySelectorAll("[data-pr-flash-save-plain]").forEach(function (el) {
      el.textContent = formatMoney(save);
    });
    document.querySelectorAll("[data-pr-flash-save-wrap]").forEach(function (el) {
      el.hidden = !(save > 0);
    });
    document.querySelectorAll("[data-pr-flash-progress]").forEach(function (el) {
      el.style.width = progress + "%";
    });

    document.querySelectorAll("[data-pr-flash-pdp]").forEach(function (el) {
      if (offerVisible() && !productIsGiftCard) {
        el.hidden = false;
        el.classList.add("is-open");
        el.classList.remove("is-leaving");
      } else if (el.classList.contains("is-open") && !el.classList.contains("is-leaving")) {
        el.classList.add("is-leaving");
        window.setTimeout(function () {
          el.classList.remove("is-open", "is-leaving");
          el.hidden = true;
        }, 260);
      } else if (!el.classList.contains("is-leaving")) {
        el.classList.remove("is-open");
        el.hidden = true;
      }
    });

    if (popup && !live) popup.classList.remove("is-open");

    var showCartDeal = offerVisible();
    document.querySelectorAll("[data-pr-flash-cart]").forEach(function (cartFlash) {
      cartFlash.hidden = !showCartDeal;
      cartFlash.classList.toggle("is-open", showCartDeal);
    });

    document.querySelectorAll("[data-pr-flash-bill]").forEach(function (el) {
      el.hidden = !showCartDeal;
    });

    var bill = document.querySelector("[data-cart-bill-breakdown]");
    if (bill) {
      var basePayable = Number(bill.getAttribute("data-payable-cents") || 0);
      var mrp = Number(bill.getAttribute("data-mrp-cents") || 0);
      var delivery = Number(bill.getAttribute("data-delivery-cents") || 0);
      var flashSave = Number(bill.getAttribute("data-flash-save-cents") || 0);
      var appliedFlash = showCartDeal && flashSave > 0 ? flashSave : 0;
      var shownPayable = Math.max(0, basePayable - appliedFlash);
      var savings = mrp - shownPayable + delivery;
      if (savings < 0) savings = delivery;
      var pct = mrp > 0 ? Math.round((savings * 100) / mrp) : 0;
      var payableEl = bill.querySelector("[data-cart-total]");
      var billSave = bill.querySelector("[data-pr-flash-bill-amount]");
      var savingsLabel = bill.querySelector("[data-pr-flash-savings-label]");
      var savingsValue = bill.querySelector("[data-pr-flash-savings-value]");
      if (payableEl) payableEl.textContent = formatPaise(shownPayable);
      if (billSave && appliedFlash > 0) billSave.textContent = "-" + formatPaise(appliedFlash);
      if (savingsLabel) savingsLabel.textContent = "Total Savings " + pct + "%";
      if (savingsValue) savingsValue.textContent = "Saving " + formatPaise(savings);
    }
  }

  if (popup) {
    var closeBtn = popup.querySelector("[data-pr-flash-close]");
    if (closeBtn) closeBtn.addEventListener("click", closePopup);
  }

  function refreshCartTotal() {
    if (!nativeFetch) return Promise.resolve();
    return nativeFetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        cartTotal = Number(cart.total_price) || 0;
        cartCount = Number(cart.item_count) || 0;
        giftCardOnly = cartIsGiftCardOnly(cart);
        paint();
      })
      .catch(function () {});
  }

  var discountPush = null;
  var codeApplicable = null;

  function timeEntry(cart) {
    return (cart && cart.discount_codes || []).find(function (d) {
      return isTimeCode(d && d.code);
    });
  }

  function noteApplicability(cart) {
    if (!cart || !Number(cart.item_count)) {
      codeApplicable = false;
      return;
    }
    var entry = timeEntry(cart);
    if (!entry) return;
    codeApplicable = !!entry.applicable;
  }

  function offerVisible() {
    return isLive() && codeApplicable === true && !giftCardOnly && cartCount > 0;
  }

  function maybeOpenLoadToast() {
    if (!popup || popup.classList.contains("is-open")) return;
    if (state.toastDismissed || !popupAllowed() || !offerVisible()) return;
    openPopup("load");
  }

  function codesOn(cart) {
    return (cart.discount_codes || [])
      .map(function (d) {
        return String((d && d.code) || "").trim().toUpperCase();
      })
      .filter(Boolean);
  }

  function sameCodes(a, b) {
    return a.slice().sort().join(",") === b.slice().sort().join(",");
  }

  function targetCodes(cart) {
    if (pendingUserCode !== null) return discountFor(pendingUserCode, cart).split(",").filter(Boolean);
    var userCodes = codesOn(cart).filter(function (c) {
      return !isTimeCode(c) && !isWalletCode(c);
    });
    return discountFor(userCodes.length ? userCodes[userCodes.length - 1] : "", cart).split(",").filter(Boolean);
  }

  function reloadCartOnce(key) {
    if (pageType !== "cart") return;
    var stamp = "";
    try {
      stamp = sessionStorage.getItem("pr_flash_discount_reload") || "";
      if (stamp === key) return;
      sessionStorage.setItem("pr_flash_discount_reload", key);
    } catch (e) {
      return;
    }
    window.location.reload();
  }

  function syncDiscounts() {
    if (!nativeFetch) return Promise.resolve();
    var gen = syncGen;
    return nativeFetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (gen !== syncGen) return;
        if (!cart) return;
        cartCount = Number(cart.item_count) || 0;
        cartTotal = Number(cart.total_price) || 0;
        giftCardOnly = cartIsGiftCardOnly(cart);
        noteApplicability(cart);
        paint();
        maybeOpenLoadToast();
        var have = codesOn(cart);
        var want;
        if (!cartCount) {
          checkoutDiscount = "";
          syncCheckoutCodes();
          paint();
          if (isLive() || !have.some(isTimeCode)) return;
          want = have.filter(function (c) {
            return !isTimeCode(c);
          });
        } else {
          want = targetCodes(cart);
        }
        checkoutDiscount = want.join(",");
        syncCheckoutCodes();
        if (sameCodes(want, have)) {
          pendingUserCode = null;
          if (isLive() || !have.some(isTimeCode)) {
            try {
              sessionStorage.removeItem("pr_flash_discount_reload");
            } catch (e) {}
          }
          var timeNow = (cart.discount_codes || []).find(function (d) {
            return isTimeCode(d && d.code);
          });
          if (isLive() && !giftCardOnly && timeNow && timeNow.applicable && pageType === "cart") {
            var bill = document.querySelector("[data-cart-bill-breakdown]");
            if (bill && bill.getAttribute("data-flash-applied") !== "1") reloadCartOnce("applied:" + want.join(","));
          }
          return;
        }
        var key = want.join(",");
        if (gen !== syncGen) return;
        if (discountPush === key) return;
        discountPush = key;
        return nativeFetch("/cart/update.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ discount: key }),
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (updated) {
            if (!updated) return;
            pendingUserCode = null;
            cartTotal = Number(updated.total_price) || cartTotal;
            if (typeof updated.item_count === "number") cartCount = updated.item_count;
            var applied = targetCodes(updated);
            checkoutDiscount = applied.join(",");
            syncCheckoutCodes();
            noteApplicability(updated);
            paint();
            maybeOpenLoadToast();
            var timeNow = timeEntry(updated);
            if (isLive() && !giftCardOnly && timeNow && timeNow.applicable) reloadCartOnce("applied:" + key);
            if (!timeNow && (!isLive() || giftCardOnly)) reloadCartOnce("removed:" + key);
          });
      })
      .catch(function () {});
  }

  function stripTimeCode(cart) {
    var kept = codesOn(cart).filter(function (c) {
      return !isTimeCode(c);
    });
    return nativeFetch("/cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ discount: kept.join(",") }),
    }).then(function (r) {
      return r.json();
    }).catch(function () {
      return null;
    });
  }

  function applyAndCheckTimeCode() {
    if (!nativeFetch) return Promise.resolve(false);
    return nativeFetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (!cart || !Number(cart.item_count)) {
          codeApplicable = false;
          return false;
        }
        var want = codesOn(cart).filter(function (c) {
          return !isTimeCode(c);
        });
        if (want.indexOf(code) === -1) want.push(code);
        return nativeFetch("/cart/update.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ discount: want.join(",") }),
        }).then(function (r) {
          return r.json();
        }).then(function (updated) {
          var entry = timeEntry(updated);
          var ok = !!(entry && entry.applicable);
          codeApplicable = ok;
          if (ok) return true;
          if (entry) return stripTimeCode(updated).then(function () { return false; });
          return false;
        });
      })
      .catch(function () {
        codeApplicable = false;
        return false;
      });
  }

  function onCartAdded(body) {
    var giftAdd = addedIsGiftCard(body) || (!body && productIsGiftCard);
    var already = isLive();
    discountPush = null;
    refreshCartTotal().then(function () {
      if (giftAdd) return syncDiscounts();
      if (!already) return applyAndCheckTimeCode();
      return syncDiscounts();
    }).then(function (ok) {
      if (giftAdd) return;
      if (!already) {
        if (ok !== true) {
          codeApplicable = false;
          paint();
          return;
        }
        startTimer();
        codeApplicable = true;
      }
      return syncDiscounts();
    }).then(function () {
      if (giftAdd) return;
      paint();
      if (codeApplicable === true && popupAllowed()) openPopup("atc");
    });
  }

  function readAdded(res) {
    if (!res || typeof res.clone !== "function") return Promise.resolve(null);
    return res.clone().json().catch(function () {
      return null;
    });
  }

  function urlOf(input) {
    if (!input) return "";
    if (typeof input === "string") return input;
    if (input.url) return input.url;
    return String(input);
  }

  function classify(url) {
    if (/\/cart\/add(\.js)?(\?|$)/.test(url)) return "add";
    if (/\/cart\/(change|update)(\.js)?(\?|$)/.test(url)) return "change";
    return "";
  }

  if (window.fetch) {
    var wrappedFetch = window.fetch;
    window.fetch = function (input) {
      var kind = classify(urlOf(input));
      var p = wrappedFetch.apply(this, arguments);
      if (kind) {
        p.then(function (res) {
          if (!res || !res.ok) return;
          if (kind === "add") {
            readAdded(res).then(onCartAdded);
          } else refreshCartTotal();
        }).catch(function () {});
      }
      return p;
    };
  }

  if (window.XMLHttpRequest) {
    var xhrOpen = XMLHttpRequest.prototype.open;
    var xhrSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__prFlashKind = classify(String(url || ""));
      return xhrOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      if (xhr.__prFlashKind) {
        xhr.addEventListener("load", function () {
          if (xhr.status < 200 || xhr.status >= 300) return;
          if (xhr.__prFlashKind === "add") {
            var body = null;
            try {
              body = JSON.parse(xhr.responseText || "");
            } catch (e) {}
            onCartAdded(body);
          } else refreshCartTotal();
        });
      }
      return xhrSend.apply(this, arguments);
    };
  }

  function syncCheckoutCodes() {
    if (checkoutDiscount === null) return;
    var value = checkoutDiscount;
    document.querySelectorAll('form[action*="cart"], form[action="/cart"]').forEach(function (form) {
      if (/\/cart\/add/.test(form.getAttribute("action") || "")) return;
      var input = form.querySelector("input[data-pr-flash-discount]");
      if (!value) {
        if (input) input.remove();
        return;
      }
      if (!input) {
        input = document.createElement("input");
        input.type = "hidden";
        input.name = "discount";
        input.setAttribute("data-pr-flash-discount", "1");
        form.appendChild(input);
      }
      input.value = value;
    });
    document.querySelectorAll('a[href*="/checkout"]').forEach(function (a) {
      try {
        var url = new URL(a.href, window.location.origin);
        if (value) url.searchParams.set("discount", value);
        else url.searchParams.delete("discount");
        a.href = url.pathname + url.search + url.hash;
      } catch (err) {}
    });
  }

  paint();
  syncDiscounts();
  var wasLive = isLive();
  window.setInterval(function () {
    paint();
    syncCheckoutCodes();
    var live = isLive();
    if (wasLive && !live) {
      discountPush = null;
      syncDiscounts();
    }
    wasLive = live;
  }, 1000);
})();
